import type { ProjectFieldFilters } from '../types';

export const CUSTOM_FIELD_KEYS = {
  all: ['customFields'] as const,
  byOrg: (orgId: string) => ['customFields', orgId] as const,
  byProject: (orgId: string, projectId: string) => ['customFields', orgId, projectId] as const,
  list: (orgId: string, projectId: string, filters?: ProjectFieldFilters) =>
    ['customFields', orgId, projectId, 'list', filters ?? {}] as const,
  taskValues: (orgId: string, taskId: string) => ['customFields', orgId, 'values', taskId] as const,
  taskValuesBatch: (orgId: string, projectId: string, taskIds: string[], fieldIds: string[]) =>
    [
      'customFields',
      orgId,
      projectId,
      'valuesBatch',
      [...taskIds].sort(),
      [...fieldIds].sort(),
    ] as const,
};
